import { render, staticRenderFns } from "./_NewArrivals.vue?vue&type=template&id=2cf50624&"
import script from "./_NewArrivals.vue?vue&type=script&lang=js&"
export * from "./_NewArrivals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports